import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { electionUrl } from '../../../globals';
import Icon from './Icon';
import IconPair from '../../assets/images/polls/icon-pair.svg';
import Paragraph from './Paragraph';
import Section from './Section';
import TwoCols from '../structure/TwoCols';
import VoiceLink from './Link';

export default function TrustVoiceSection({ background }) {
  const { t } = useTranslation();

  return (
    <Section
      background={background}
      content={(
        <>
          <TwoCols
            leftSpan={3}
            rightSpan={9}
            alignItems="center"
            left={(
              <Icon
                src={IconPair}
                alt={t('polls_icon_pair')}
              />
            )}
            right={(
              <>
                <Paragraph
                  title={t('const_whyVoice_trust')}
                >
                  {t('const_whyVoice_p_1')}
                </Paragraph>
                <Paragraph>
                  {t('const_whyVoice_p_2')}
                </Paragraph>
                <Paragraph>
                  {t('const_whyVoice_p_3')}
                  <VoiceLink
                    color="primary"
                    href={electionUrl}
                  >
                    {t('const_interactive_map')}
                  </VoiceLink>
                  {t('and')}
                  <VoiceLink
                    color="primary"
                    href="http://bit.ly/golos-final-report"
                  >
                    {t('const_final_report')}
                  </VoiceLink>
                </Paragraph>
                <Paragraph>
                  {t('const_whyVoice_p_4')}
                </Paragraph>
              </>
            )}
          />
        </>
      )}
    />
  );
}

TrustVoiceSection.defaultProps = {
  background: 'gray',
};
TrustVoiceSection.propTypes = {
  background: PropTypes.oneOf(['white', 'gray', 'blue']),
};
